import React from "react";
import { useLocation, Route, Routes } from "react-router-dom";
import { useSelector } from 'react-redux'; 
import ScrollToTop from "react-scroll-to-top";
import { Container } from "reactstrap";

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import Index from "views/Index.js";
import Profile from '../views/examples/profile/Profile'
import AddNewDevice from '../views/examples/profile/AddNewDevice'
import ApiKeys from '../views/examples/developer/ApiKeys'
import Support from '../views/examples/support/Support'
import Map from '../views/examples/map/Map'
import PrescriptionMap from '../views/examples/map/PrescriptionMap'
import InsuranceAccount from '../views/examples/insurance/InsuranceAccount'
import ConnectInsuranceService from '../views/examples/insurance/ConnectInsuranceService'
import ConnectInsuranceServiceCreate from '../views/examples/insurance/ConnectInsuranceServiceCreate'
import ConnectInsuranceServiceDelete from '../views/examples/insurance/ConnectInsuranceServiceDelete'
import ListRequestInsurance from '../views/examples/insurance/ListRequestInsurance'
import InsuranceListDevice from '../views/examples/insurance/InsuranceListDevice'
import MapInsurance from '../views/examples/insurance/MapInsurance'
import DataTable from '../views/examples/datatable/DataTable'
import InsuranceTable from '../views/examples/insurance/InsuranceTable'
import InsuranceComparation from '../views/examples/insurance/InsuranceComparation'

import DamageList from '../views/examples/damage/DamageList'
import DamageCreate from '../views/examples/damage/DamageCreate'
import DamageDelete from '../views/examples/damage/DamageDelete'
import DamageUpdate from '../views/examples/damage/DamageUpdate'
import DamageInsuranceList from '../views/examples/damage/DamageInsuranceList'

import FotoNormalUser from '../views/examples/foto/FotoNormalUser'
import FotoInsuranceUser from '../views/examples/foto/FotoInsuranceUser'
import MobilePhoneInsurance from '../views/examples/foto/MobilePhoneInsurance'

import AddNewModels from '../views/examples/profile/AddNewModels'
import DataManagement from '../views/examples/datamanagement/DataManagement'

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    if (mainContent.current) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      mainContent.current.scrollTop = 0;
    }
  }, [location]);

  const is_developer = useSelector((state) => state.userLogin.userInfo.is_developer);

  const is_insurance_profile = useSelector((state) => state.userLogin.userInfo.is_insurance_profile);

  return (
    <>
      <ScrollToTop smooth color="#6f00ff" />
      <Sidebar
        {...props}
        logo={{
          innerLink: "/",
          imgSrc: require("../assets/img/brand/argon-react.png"),
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={"Marco"}
        />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/profile/" element={<Profile />} /> 
          <Route path="/add-new-device/" element={<AddNewDevice />} />
          <Route path="/add-new-models/" element={<AddNewModels />} />        
          <Route path="/support/" element={<Support />} /> 

          <Route path="/data/" element={<DataTable />} />
          <Route path="/data-management/" element={<DataManagement />} /> 
          <Route path="/map/" element={<Map />} />             
          <Route path="/prescription-map/" element={<PrescriptionMap />} />          

          <Route path="/photo/" element={<FotoNormalUser />} /> 
          
          <Route path="/connect-insurance-service/" element={<ConnectInsuranceService />} /> 
          <Route path="/create-insurance-connection/" element={<ConnectInsuranceServiceCreate />} />
          <Route path="/delete-insurance-connection/:fieldId" element={<ConnectInsuranceServiceDelete />} /> 

          <Route path="/damage/" element={<DamageList />} />  
          <Route path="/create-damage/" element={<DamageCreate />} />  
          <Route path="/delete-damage/:fieldId" element={<DamageDelete />} />  
          <Route path="/update-damage/:fieldId" element={<DamageUpdate />} />  

          {is_developer ? (
            <>
              <Route path="/api/" element={<ApiKeys />} /> 
            </>
          ):(
            <>
            </>
          )}

          {is_insurance_profile ? (
            <>
              <Route path="/insurance-profile/" element={<InsuranceAccount />} /> 
              <Route path="/list-request/" element={<ListRequestInsurance />} /> 
              <Route path="/list-devices/" element={<InsuranceListDevice />} /> 
              <Route path="/map-insurance/" element={<MapInsurance />} /> 
              <Route path="/insurance-table/" element={<InsuranceTable />} /> 
              <Route path="/insurance-comparation/" element={<InsuranceComparation />} /> 
              <Route path="/damage-list-insurance/" element={<DamageInsuranceList />} /> 
              <Route path="/insurance-photo/" element={<FotoInsuranceUser />} />      
              <Route path="/insurance-mobile-data/" element={<MobilePhoneInsurance/>}></Route>        
              
            </>
          ):(
            <>
            </>
          )}
        </Routes>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
        
    </>
  );
};

export default Admin;
